package com.example.mystybag.sharedmodels.appConfig


import com.example.mystybag.sharedmodels.UtilsCurrenciesAndCountriesDefines.COUNTRY_CODE_ISO_BG
import com.example.mystybag.sharedmodels.UtilsCurrenciesAndCountriesDefines.COUNTRY_CODE_ISO_DE
import com.example.mystybag.sharedmodels.UtilsCurrenciesAndCountriesDefines.COUNTRY_CODE_ISO_EL
import com.example.mystybag.sharedmodels.UtilsCurrenciesAndCountriesDefines.COUNTRY_CODE_ISO_EN
import com.example.mystybag.sharedmodels.UtilsCurrenciesAndCountriesDefines.COUNTRY_CODE_ISO_ES
import com.example.mystybag.sharedmodels.UtilsCurrenciesAndCountriesDefines.COUNTRY_CODE_ISO_FR
import com.example.mystybag.sharedmodels.UtilsCurrenciesAndCountriesDefines.COUNTRY_CODE_ISO_IT
import com.example.mystybag.sharedmodels.UtilsCurrenciesAndCountriesDefines.COUNTRY_CODE_ISO_NL
import com.example.mystybag.sharedmodels.UtilsCurrenciesAndCountriesDefines.COUNTRY_CODE_ISO_RO
import kotlinx.serialization.Serializable

@Serializable
data class ApplicationsConfigModel(
    val id                                      : Long                              = 1L,
    val languages                               : List<String>                      = listOf(
        COUNTRY_CODE_ISO_BG,
        COUNTRY_CODE_ISO_EN,
        COUNTRY_CODE_ISO_DE,
        COUNTRY_CODE_ISO_FR,
        COUNTRY_CODE_ISO_NL,
        COUNTRY_CODE_ISO_IT,
        COUNTRY_CODE_ISO_RO,
        COUNTRY_CODE_ISO_EL,
        COUNTRY_CODE_ISO_ES
    ),
    val showAuthorizeActivity                   : Boolean                           = false,
    val showWelcomeToolbar                      : Boolean                           = false,
    val showBackButton                          : Boolean                           = false
)